// ========================================
// MONTAGEM DO MODAL DE ERRO
// src/utils/modalErro.js
//
// Quando o backend (ou a validação local) recusa um texto digitado, o erro vem
// com `codigo: 'CONTEUDO_BLOQUEADO'`, o campo, o motivo e o trecho. Isso não é
// falha do sistema: é algo que o usuário consegue corrigir. Então vira um aviso
// dizendo o que ajustar, e não um "Erro ao salvar" genérico.
// ========================================

/**
 * Monta o objeto passado para showModal a partir de um erro de requisição.
 *
 * @param {Error} erro          erro capturado no catch
 * @param {object} opcoes
 * @param {string} opcoes.titulo   título usado quando é erro comum
 * @param {string} opcoes.prefixo  texto antes da mensagem em erro comum
 */
export const montarModalErro = (erro, { titulo = 'Erro', prefixo = '' } = {}) => {
    const mensagem = erro?.message || 'Erro inesperado.';

    if (erro?.codigo === 'CONTEUDO_BLOQUEADO') {
        return {
            type: 'warning',
            title: 'Ajuste necessário para salvar',
            message: mensagem,
            confirmText: 'Entendi',
            showCancel: false
        };
    }

    return {
        type: 'error',
        title: titulo,
        message: prefixo ? prefixo + mensagem : mensagem,
        confirmText: 'OK',
        showCancel: false
    };
};

export default { montarModalErro };
